import app from 'flarum/common/app';
export default function languageName(code) {
  try {
    return new Intl.DisplayNames([app.translator.getLocale()], {
      type: 'language'
    }).of(code) ?? code;
  } catch {
    return code;
  }
}
flarum.reg.add('glowingblue-translate', 'common/utils/languageName', languageName);